import {DialogTypeEnum} from '@shared/module/dialog/model/enum';

export interface DialogConfigInterface {
  id: string;
  show: boolean;
  isFirstPlan: boolean;
  title?: string;
  type?: DialogTypeEnum;
}
